import 'twin.macro';
import tw from 'twin.macro';
import { resolveScoreStyles } from '../../features/exercise/helpers';

// Mobile-only corner ribbon combining the live score and fps into a single
// color-coded flag anchored to the bottom-right corner — colored by score
// thresholds (see resolveScoreStyles), or red while isFalseStage flags a bad
// rep. The rep counter itself stays in its original top-left pill.
const MobileScoreFrameRibbon = ({ score, hasScore = true, fps, isFalseStage, scoreStyles }) => {
  const ribbonStyles = isFalseStage
    ? tw`bg-[rgba(153,27,27,0.9)] border-[#FCA5A5] text-white`
    : scoreStyles || resolveScoreStyles(score ?? null);

  return (
    <div
      tw="fixed bottom-0 right-0 z-[100] flex items-center gap-3 pl-3 pr-5 py-1.5 border-b-[2px] border-r-[2px] shadow-[0_8px_20px_rgba(0,0,0,0.35)] [clip-path:polygon(0_0,100%_0,85%_100%,0_100%)]"
      css={ribbonStyles}
    >
      <div tw="flex flex-col items-start leading-none">
        <span tw="text-[9px] font-[600] uppercase tracking-[0.08em] opacity-80">Score</span>
        <span tw="min-w-[3ch] text-[16px] font-[800] tabular-nums">
          {hasScore ? (score ?? '-') : '-'}
        </span>
      </div>
      <div tw="w-[1px] h-[22px] bg-white/30" />
      <div tw="flex flex-col items-start leading-none">
        <span tw="text-[9px] font-[600] uppercase tracking-[0.08em] opacity-80">FPS</span>
        <span tw="min-w-[2ch] text-[16px] font-[800] tabular-nums">{fps ?? '-'}</span>
      </div>
    </div>
  );
};

export default MobileScoreFrameRibbon;
